import { ResponseDTO } from '@/types';
import { ReportDTO } from '@/types/report';
import request from '@/utils/request';

export function getReport(id: number): Promise<ReportDTO> {
  return request
    .get<ReportDTO, ResponseDTO<ReportDTO>, void>(`/reports/${id}`)
    .then((res) => res.data);
}
